import { Container, Row, Col, Button } from "react-bootstrap";
import { encrypt, decrypt } from "@/utils/crypto";

const SignOutPage = ({ session_id }) => {
  const handleSignOutAndContinue = () => {
    // Construct the new URL based on the session_id
    // Get the current URL and replace only the last segment (id)
    const currentUrl = window.location.href;
    const baseUrl = currentUrl.substring(0, currentUrl.lastIndexOf("/"));
    const newUrl = session_id
      ? `${baseUrl}/${encrypt(decrypt(session_id))}`
      : baseUrl;

    // Clear localStorage
    localStorage.clear();

    // Clear sessionStorage
    sessionStorage.clear();

    // Reload the page after a short delay to ensure all clearing operations complete
    setTimeout(() => {
      window.location.replace(newUrl);
    }, 100);
  };

  return (
    <section className="bg-primary min-h-screen hstack">
      <Container>
        <Row>
          <Col className="mx-auto">
            <div className="mt-10 text-center">
              <h2 className="text-light mb-4 text-26">
                Oops! You'll need to sign out first.
              </h2>

              <p className="text-light mb-3 text-17">
                You are currently logged in as an admin.
              </p>

              <p className="text-light mb-8 text-17">
                Please sign out to join this session as a participant.
              </p>

              <div className="px-2">
                <Button
                  className="w-fit mt-6 mb-3 text-19 font-normal px-14 py-4 btn btn-secondary btn-xl"
                  onClick={handleSignOutAndContinue}
                >
                  Sign out and continue
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SignOutPage;
